import user from "../assets/user.svg"

function DashboardHeader(props) {
 
  return (
   <div className="dashboard-header">
       <h2 className="dh-title">{props.title}</h2>
       <div className="user-prof">
            <img className="user-icon" src={user} alt="icon" />
           <h4>{props.profilename}</h4>
       </div>
   </div>
  )
}

export default DashboardHeader